export default "__VITE_ASSET__41f00e64__"